document.addEventListener('DOMContentLoaded', () => {
	const naviSP = document.querySelector('.nav-sp');
  const parentLis = naviSP.querySelectorAll(
    '.wp-block-navigation-item:has(> .wp-block-navigation__submenu-container)'
  );
	const buttonOpen = naviSP.querySelector('.wp-block-navigation__responsive-container-open');
	const buttonClose = naviSP.querySelector('.wp-block-navigation__responsive-container-close');
	buttonOpen.addEventListener('click', (e) => {
		if (document.documentElement.classList.contains('has-modal-open')) {
			document.documentElement.classList.remove('has-modal-open');
			const naviContent = naviSP.querySelector('.wp-block-navigation__responsive-container');
			naviContent.classList.add('is-menu-open', 'has-modal-open');
			naviContent.setAttribute('aria-hidden', 'false');
		}
	});
  parentLis.forEach((originalLi) => {
    const submenu = originalLi.querySelector(':scope > .wp-block-navigation__submenu-container');
    const parentLink = originalLi.querySelector(':scope > a.wp-block-navigation-item__content');
    if (!submenu || !parentLink) return;
    if (originalLi.classList.contains('wp-block-navigation-item-accordion')) return;

    const title = parentLink.textContent.trim() || 'Menu';

    originalLi.classList.add('wp-block-navigation-item-accordion');

    const button = document.createElement('button');
    button.type = 'button';
    button.classList.add('wp-block-navigation-item-accordion__button');
    button.setAttribute('aria-expanded', 'false');
    button.textContent = title;

    const innerUl = document.createElement('ul');
    innerUl.classList.add('wp-block-navigation-item-accordion__inner');

    // 初期：閉じ
    innerUl.hidden = true;
    innerUl.style.maxHeight = '0px';

    // 親aとsubmenuをliで包んでinnerUlへ移動
    const linkLi = document.createElement('li');
    linkLi.classList.add(
      'wp-block-navigation-item',
      'wp-block-navigation-link',
      'wp-block-navigation-item-accordion__parent-link'
    );
    linkLi.appendChild(parentLink);

    const submenuLi = document.createElement('li');
    submenuLi.appendChild(submenu);

    innerUl.appendChild(linkLi);
    innerUl.appendChild(submenuLi);

    const open = () => {
      button.setAttribute('aria-expanded', 'true');
      innerUl.hidden = false;
      // hidden解除後に高さ計測して max-height へ
      const h = innerUl.scrollHeight;
      innerUl.style.maxHeight = `${h}px`;
    };

    const close = () => {
      button.setAttribute('aria-expanded', 'false');
      // まず現在高をセット→0へ（アニメのため）
      innerUl.style.maxHeight = `${innerUl.scrollHeight}px`;
      requestAnimationFrame(() => {
        innerUl.style.maxHeight = '0px';
      });
    };

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      if (expanded) close();
      else open();
    });

    // アニメ終わったら hidden を戻す（クリック不可＆tab移動防止）
    innerUl.addEventListener('transitionend', (e) => {
      if (e.propertyName !== 'max-height') return;
      const expanded = button.getAttribute('aria-expanded') === 'true';
      if (!expanded) innerUl.hidden = true;
      else innerUl.style.maxHeight = 'none'; // 開いた後は可変にする（中身増えてもOK）
    });

    originalLi.prepend(button);
    originalLi.appendChild(innerUl);
  });
});